"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Snippets = require("snippets");
var next_components_1 = require("@dotdev/next-components");
var ProductItemQty = /** @class */ (function (_super) {
    __extends(ProductItemQty, _super);
    function ProductItemQty() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProductItemQty.prototype.render = function () {
        var _a, _b, _c, _d, _e, _f, _g;
        var _h = this.props, quantity = _h.quantity, max = _h.max, className = _h.className, handleQtyChange = _h.handleQtyChange, isPreorder = _h.isPreorder, product = _h.data.product;
        var maxNumber = max || 0;
        var preorder = (_c = (_b = (_a = product) === null || _a === void 0 ? void 0 : _a.preorderme) === null || _b === void 0 ? void 0 : _b.product_settings) === null || _c === void 0 ? void 0 : _c[(_d = product) === null || _d === void 0 ? void 0 : _d.selected_or_first_available_variant];
        if (preorder && ((_e = preorder) === null || _e === void 0 ? void 0 : _e.qty)) {
            maxNumber = ((_f = preorder) === null || _f === void 0 ? void 0 : _f.qty) - ((_g = preorder) === null || _g === void 0 ? void 0 : _g.sold);
        }
        var decreaseBtnExtraClasses = quantity <= 1 ? " opacity-50 pointer-events-none" : "";
        var increaseBtnExtraClasses = !isPreorder && quantity >= maxNumber ? " opacity-50 pointer-events-none" : "";
        return (React.createElement("div", { className: "flex items-center justify-around text-arctic " + (className || "") },
            React.createElement("button", { type: "button", className: "flex items-center justify-center focus:outline-none" + decreaseBtnExtraClasses, onClick: function () { return handleQtyChange("-"); }, title: "Decrease quantity", "aria-label": "Decrease quantity" },
                React.createElement(Snippets.Svg, { name: "minus", width: 16, className: "block" })),
            React.createElement("input", { className: "text-center text-md text-arctic font-bold font-body w-4 h-4 appearance-none border-none outline-none focus:outline-none bg-water-blue rounded-half", type: "text", id: "quantity", name: "quantity", value: quantity, min: 1, max: maxNumber || null, pattern: "[0-9]*", readOnly: true }),
            React.createElement("button", { type: "button", className: "flex items-center justify-center focus:outline-none" + increaseBtnExtraClasses, onClick: function () { return quantity < maxNumber && handleQtyChange("+"); }, title: "Increase quantity", "aria-label": "Increase quanfffftity" },
                React.createElement(Snippets.Svg, { name: "plus", width: 16, className: "block" }))));
    };
    return ProductItemQty;
}(React.PureComponent));
exports.ProductItemQty = ProductItemQty;
ProductItemQty.contextType = next_components_1.ShopifyNext.Context;
